export default __webpack_public_path__ + "static/media/complementary--except-carts--g1.68857953.png";